import { DatePipe } from "@angular/common";

export class ClientModel {

	clientId: string;
	fullName: string;
	poisition : string;
	email : string;
	email2 : string;
	phone1: string;
	phone2 : string;
//	phone3 : string;
	ext1 : string;
	ext2 : string;
//	ext3 : string;
	company : string;
	address : string;
	provinceCode : string;
	zipCode : string;
	countryCode : string;
	status : string;
	note : string;
	createBy : string;
	createTime : DatePipe;
}
export class ClientDetailModel extends ClientModel {
	countryName : string;
}
